import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { footer } from '../../data/mock';

const Footer = () => {
  const { language } = useLanguage();
  const f = footer[language];
  const currentYear = new Date().getFullYear();

  return (
    <footer className="absolute bottom-0 left-0 right-0 py-3 sm:py-4 px-4 sm:px-6 z-20">
      <div className="max-w-7xl mx-auto flex flex-wrap items-center justify-center md:justify-end gap-x-3 gap-y-1 sm:gap-x-4 text-white/70 text-[10px] sm:text-xs">
        <Link to="/aviso-legal" className="hover:text-white transition-colors">
          {f.legal}
        </Link>
        <span className="hidden sm:inline">|</span>
        <Link to="/politica-privacidad" className="hover:text-white transition-colors">
          {f.privacy}
        </Link>
        <span className="hidden sm:inline">|</span>
        <Link to="/politica-cookies" className="hover:text-white transition-colors">
          {f.cookies}
        </Link>
        <span className="hidden sm:inline">|</span>
        <Link to="/canal-etico" className="hover:text-white transition-colors">
          {f.ethics}
        </Link>
        <span className="hidden sm:inline">|</span>
        <Link to="/politica-seguridad" className="hover:text-white transition-colors">
          {f.security}
        </Link>
        <span className="hidden sm:inline">|</span>
        <span>© {currentYear} Okuant. {f.rights}</span>
      </div>
    </footer>
  );
};

export default Footer;
